const isAuth = (user) => {
    if (!user.token) return false
    if (user.exp > Date.now()) return true
    return false
}

export default isAuth